import { stats } from "@/mocks/comics";

export default function Hero() {
  return (
    <section id="home" className="relative w-full min-h-[560px] md:min-h-[640px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://comtock.github.io/api/search-image?query=dark%20artistic%20webtoon%20collage%20background%20with%20abstract%20ink%20brush%20strokes%2C%20glowing%20crimson%20and%20amber%20energy%20light%2C%20floating%20comic%20panels%20and%20dragon%20silhouette%2C%20cinematic%20moody%20atmosphere%2C%20stylized%20manhwa%20aesthetic%20with%20rich%20texture&width=1600&height=900&seq=hero-manhwa-2026&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-background-50"></div>

      <div className="relative z-10 w-full mx-auto max-w-7xl px-4 md:px-6 py-20 md:py-28 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/20 text-accent-200 border border-accent-300/40 px-4 py-1.5 text-xs md:text-sm">
          <i className="ri-flashlight-line"></i>
          韩漫yy今日连载已同步 · 每日定时更新
        </span>
        <h1 className="mt-6 font-heading text-4xl md:text-6xl text-white leading-tight">
          韩国漫画yy
          <span className="block mt-2 text-accent-300">每日更新 · 追更提醒不错过</span>
        </h1>
        <p className="mt-6 max-w-2xl mx-auto text-sm md:text-base text-white/80 leading-relaxed">
          热门韩漫最新章节第一时间同步，设置追更提醒不错过任何更新，每日打开都有新内容可看，追更体验更流畅。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#updates"
            className="w-full sm:w-auto inline-flex items-center justify-center whitespace-nowrap rounded-md px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-play-list-2-line mr-2"></i>看今日更新
          </a>
          <a
            href="#feature"
            className="w-full sm:w-auto inline-flex items-center justify-center whitespace-nowrap rounded-md px-6 py-3 text-sm font-medium bg-white/10 text-white border border-white/30 hover:bg-white/20 transition-colors cursor-pointer"
          >
            <i className="ri-notification-3-line mr-2"></i>设置追更提醒
          </a>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-white/8 border border-white/15 px-4 py-4 backdrop-blur-sm"
            >
              <div className="font-heading text-2xl md:text-3xl text-white">{s.value}</div>
              <div className="mt-1 text-xs text-white/70">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}